import { render, staticRenderFns } from "./DashboardActiveCompanyCard.vue?vue&type=template&id=472956f0&scoped=true&"
import script from "./DashboardActiveCompanyCard.vue?vue&type=script&lang=js&"
export * from "./DashboardActiveCompanyCard.vue?vue&type=script&lang=js&"
import style0 from "./DashboardActiveCompanyCard.vue?vue&type=style&index=0&id=472956f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472956f0",
  null
  
)

export default component.exports